export const Laundary = {
    label: "Laundry",
    children: [
      {
        label: "W & F(Wearables)",
        viewPrice: "80/kg",
        Price: 80,
        newQtyPrice: 80,
        img : `w_f_wearable.jpg`,
        type: 'laundry'

      },
      {
        label: "W & F(Non-Wearables)",
        viewPrice: "100/kg",
        Price: 100,
        newQtyPrice: 100,
        type: 'laundry',
        img : `w_f_non-wearable.jpg`
      },
      {
        label: "W & I(Wearables)",
        viewPrice: "100/kg",
        Price: 100,
        newQtyPrice: 100,
        type: 'laundry',
        img : `w_i_wearable.jpg`
      },
      {
        label: "W & I(Non-Wearables)",
        viewPrice: "120/kg",
        Price: 120,
        newQtyPrice: 120,
        type: 'laundry',
        img : `w_i_non-wearable.jpg`
      },
    ],
  };

export const Dryclean =  
{
    label: "DryClean",
    children: [
      {
        label: "Shirt/T-shirt",
        Price: 100,
        viewPrice: "100/pc",
        newQtyPrice: 100,
        type: 'DryClean',
        img: `shirt.png`
      },
      {
        label: "Jeans",
        Price: 120,
        viewPrice: "120/pc",
        newQtyPrice: 120,
        type: 'DryClean',
        img: `jeans.png` 
      },
      {
        label: "Trousers",
        Price: 100,
        viewPrice: "100/pc",
        newQtyPrice: 100,
        type: 'DryClean',
        img: `trouser.png`
      },
      {
        label: "Blazer/Jacket",
        Price: 250,
        viewPrice: " 250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img: `blazer.png`
      },
      {
        label: "3 piece Suit",
        Price: 450,
        viewPrice: "450/pc",
        newQtyPrice: 450,
        type: 'DryClean',
        img: `3_pc_suit.png`
      },
      {
        label: "2 piece Suit",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img: `2_pc_suit.png`
      },
      {
        label: "Long Blazer",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img: `longblazer.png`
      },
      {
        label: "Sweatshirt /Hoodie",
        Price: 250,
        viewPrice: " 250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img: `hoodie.png`
      },
      {
        label: "Winter Jacket",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img : `winter_jacket.jpg`
      },
      {
        label: "Heavy Saree",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img: `heavysaree.png`
      },
      {
        label: "Medium Saree",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `mediumsaree.png`
      },
      {
        label: "Saree",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img : `saree.png`
      },
      {
        label: "Blouse",
        Price: 80,
        viewPrice: "80/pc",
        newQtyPrice: 80,
        type: 'DryClean',
        img : `blouse.png`
      },
      {
        label: "Heavy Blouse",
        Price: 120,
        viewPrice: "120/pc",
        newQtyPrice: 120,
        type: 'DryClean',
        img : `heavy_blouse.webp`
      },
      {
        label: "Lehnga",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img : `lehenga.png`
      },
      {
        label: "Medium Lehnga",
        Price: 500,
        viewPrice: "500/pc",
        newQtyPrice: 500,
        type: 'DryClean',
        img : `mediumlehenga.png`
      },
      {
        label: "Heavy Lehnga",
        Price: 700,
        viewPrice: "700/pc",
        newQtyPrice: 700,
        type: 'DryClean',
        img : `heavy_lehenga.jpg`
      },
      {
        label: "Heavy Dress",
        Price: 500,
        viewPrice: "500/pc",
        newQtyPrice: 500,
        type: 'DryClean',
        img : `heavy_dress.jpg`
      },
      {
        label: "Dress",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img : `dress.png`
      },
      {
        label: "Heavy Gown",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `heavy_gown.jpg`
      },
      {
        label: "Gown",
        Price: 200,
        viewPrice: "200/pc",
        newQtyPrice: 200,
        type: 'DryClean',
        img : `gown.jpg`
      },
      {
        label: "Dupatta",
        Price: 80,
        viewPrice: "80/pc",
        newQtyPrice: 80,
        type: 'DryClean',
        img : `dupatta.jpg`
      },
      {
        label: "Heavy Dupatta",
        Price: 100,
        viewPrice: "100/pc",
        newQtyPrice: 100,
        type: 'DryClean',
        img : `heavy_duptta.jpg`

      },
      {
        label: "Kurta Pyjama",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img : `kurta_pajama.jpg`
      },
      {
        label: "Shawl",
        Price: 200,
        viewPrice: "200/pc",
        newQtyPrice: 200,
        type: 'DryClean',
        img : `shwal.jpg`
      },
      {
        label: "Sweater /Cardigan",
        Price: 200,
        viewPrice: " 200/pc",
        newQtyPrice: 200,
        type: 'DryClean',
        img : `cardigin.jpg`
      },
      {
        label: "Shrug",
        Price: 200,
        viewPrice: "200/pc",
        newQtyPrice: 200,
        type: 'DryClean',
        img : `srug.jpg`

      },
      {
        label: "Leather Jackets",
        Price: 450,
        viewPrice: "450/pc",
        newQtyPrice: 450,
        type: 'DryClean',
        img : `leather_jacket.jpg`
      },
      {
        label: "Belt",
        Price: 150,
        viewPrice: "150/pc",
        newQtyPrice: 150,
        type: 'DryClean',
        img : `belt.jpg`
      },
      {
        label: "Leather Belt",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img : `leather_belt.webp`
      },
      {
        label: "Pillow Cover",
        Price: 50,
        viewPrice: "50/pc",
        newQtyPrice: 50,
        type: 'DryClean',
        img : `pillow_cover.jpg`
      },
      {
        label: "Large Pillow",
        Price: 100,
        viewPrice: "100/pc",
        newQtyPrice: 100,
        type: 'DryClean',
        img : `large_pillow.jpg`
      },
      {
        label: "Small Pillow",
        Price: 60,
        viewPrice: "60/pc",
        type: 'DryClean',
        img : `small_pillow.jpg`,
        newQtyPrice: 60,
      },
      {
        label: "Blanket(single)",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `blanket(single).jpg`,
      },
      {
        label: "Blanket(double)",
        Price: 400,
        viewPrice: "400/pc",
        newQtyPrice: 400,
        type: 'DryClean',
        img : `double_blanket.jpg`
      },
      {
        label: "Duvet(single)",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `Druvet_single.jpg`
      },
      {
        label: "Duvet(double)",
        Price: 400,
        viewPrice: "400/pc",
        newQtyPrice: 400,
        type: 'DryClean',
        img : `Druvet_double.jpg`

      },
      // {
      //   label: "Druvet(single)",
      //   Price: 300,
      //   viewPrice: "300/pc",
      //   newQtyPrice: 300,
      // },
      {
        label: "Quilt(single)",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img : `Quilt_single.jpg`
      },
      {
        label: "Quilt(double)",
        Price: 450,
        viewPrice: "450/pc",
        newQtyPrice: 450,
        type: 'DryClean',
        img : `Quilt_double.jpg`
      },
      {
        label: "Bed Cover(single)",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
        type: 'DryClean',
        img : `bed_cover_single.jpg`
      },
      {
        label: "Bed Cover(double)",
        Price: 350,
        viewPrice: "350/pc",
        newQtyPrice: 350,
        type: 'DryClean',
        img : `bed_cover_double.jpg`
      },
      {
        label: "Bed Sheet(single)",
        Price: 200,
        viewPrice: "200/pc",
        newQtyPrice: 200,
        type: 'DryClean',
        img : `bed_sheet_single.jpg`
      },
      {
        label: "Bed Sheet(double)",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `bed_sheet_double.jpg`
      },
      {
        label: "Handbag(Small)",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
        type: 'DryClean',
        img : `handbag_small.jpeg`
      },
      {
        label: "Handbag(Medium)",
        Price: 450,
        viewPrice: "450/pc",
        newQtyPrice: 450,
        type: 'DryClean',
        img : `handbag_medium.jpg`
      },
      {
        label: "Handbag(Large)",
        Price: 450,
        viewPrice: "450/pc",
        newQtyPrice: 450,
        type: 'DryClean',
        img : `handbag_large.jpg`
      },
      {
        label: "Sports Bag",
        Price: 400,
        viewPrice: "400/pc",
        newQtyPrice: 400,
        type: 'DryClean',
        img : `sports_bag.jpg`
      },
      {
        label: "Leather Bag(Small)",
        Price: 400,
        viewPrice: "400/pc",
        newQtyPrice: 400,
        type: 'DryClean',
        img : `Leatherbag_small.webp`
      },
      {
        label: "Leather Bag(Large)",
        Price: 700,
        viewPrice: "700/pc",
        newQtyPrice: 700,
        type: 'DryClean',
        img : `leather_bag_large.jpg`
      },
    ],
  }

  export const Shoespa = {
    label: "ShoeSpa",
    children: [
      {
        label: "Sport Shoes / Sneakers",
        Price: 500,
        viewPrice: "500/pc",
        newQtyPrice: 500,
        img : `sportsshoes.png`,
        type: 'ShoeSpa',
      },
      // {
      //   label: "Sneaker",
      //   Price: 500,
      //   viewPrice: "500/pc",
      //   newQtyPrice: 500,
      //   img : `sportsshoes.png`
      // },
      {
        label: "Leather Shoes",
        Price: 600,
        viewPrice: "600/pc",
        newQtyPrice: 600,
       type: 'ShoeSpa',
        img : `leather_shoes.jpg`
      },
      {
        label: "Suede Shoes",
        Price: 600,
        viewPrice: "600/pc",
        newQtyPrice: 600,
       type: 'ShoeSpa',
        img : `suedeshoes.png`
      },
      {
        label: "Boots",
        Price: 700,
        viewPrice: "700/pc",
        newQtyPrice: 700,
       type: 'ShoeSpa',
        img : `boots.png`
      },
      {
        label: "Stilettos",
        Price: 600,
        viewPrice: "600/pc",
        newQtyPrice: 600,
       type: 'ShoeSpa',
        img : `stilettos.png`
      },
      {
        label: "Sliders",
        Price: 250,
        viewPrice: "250/pc",
        newQtyPrice: 250,
       type: 'ShoeSpa',
        img : `sliders.png`
      },
      {
        label: "Sandals",
        Price: 300,
        viewPrice: "300/pc",
        newQtyPrice: 300,
       type: 'ShoeSpa',
        img : `sandals.png`
      },
    ],
  }